import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';

//Page Lazy loading
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));
const LoginLoader = Loadable(lazy(() => import('pages/auth/jwt/LoginLoader')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const Profile = Loadable(lazy(() => import('pages/profile')));
const Dashboard = Loadable(lazy(() => import('pages/dashboard/dashboard')));
const AllCards = Loadable(lazy(() => import('pages/cards/all-cards')));
const BulkPinSet = Loadable(lazy(() => import('pages/cards/bulk-pin-set')));
const BulkPinSetReport = Loadable(lazy(() => import('pages/cards/bulk-pin-set-report')));
const CardDetails = Loadable(lazy(() => import('pages/cards/card-details')));
const AllTickets = Loadable(lazy(() => import('pages/customer-support/all-tickets')));
const TicketDetails = Loadable(lazy(() => import('pages/customer-support/ticket-details')));
const RaiseQuery = Loadable(lazy(() => import('pages/customer-support/raise-query')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'dashboard',
          element: <Dashboard />
        },
        {
          path: 'sample-page',
          element: <SamplePage />
        },
        {
          path: 'profile',
          element: <Profile />
        },
        {
          path: 'all-cards',
          element: <AllCards />
        },
        {
          path: 'bulk-pin-set',
          element: <BulkPinSet />
        },
        {
          path: 'bulk-pin-set-report',
          element: <BulkPinSetReport />
        },
        {
          path: 'card-details',
          element: <CardDetails />
        },
        {
          path: 'all-tickets',
          element: <AllTickets />
        },
        {
          path: 'ticket-details',
          element: <TicketDetails />
        },
        {
          path: 'raise-query',
          element: <RaiseQuery />
        },
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: 'loginLoader',
      element: <LoginLoader />
    },
  ],
};

export default MainRoutes;
